module.exports = __webpack_public_path__ + "img/beverages.0b6abbe2.svg";